
import { Component, Vue } from "vue-property-decorator";

@Component
export default class Footer extends Vue {
  protected render() {
    return (
      <footer>
        <p>
          &copy; 2020 Designed By Enoch Qin
          <a href="https://github.com/dreamqyq/cnode-community" target="_blank">
            源码链接 GitHub >>
          </a>
        </p>
      </footer>
    );
  }
}
